import { ajax } from '../../../services/helper'
class ApiService {

    getKitchenStaffsData = (city_id,kitchen_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kitchenStaffs/list?city_id="+city_id+"&kitchen_id="+kitchen_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

   
    getKitchenStaffById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kitchens/"+id+"/editStaffInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getKitchenStaffGroupsDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/brandGroups/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    


    addKitchenStaff = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kitchenStaffs/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    editKitchenStaff = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kitchens/"+id+"/updateStaff"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Kitchen Staffs/services/apiservices.js